package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.InviteCodes
import com.evoapps.evoshift.domain.repository.AuthRepository

class AcceptInviteUseCase(
    private val authRepository: AuthRepository
) {
    suspend operator fun invoke(code: String): Result<Unit> {
        return authRepository.acceptInvite(InviteCodes.normalize(code))
    }
}
